export const LOCATION_CHANGED = 'LOCATION_CHANGED';

export function changeLocation(latitude, longitude) {
    return {
        type: LOCATION_CHANGED,
        payload: {
            latitude,
            longitude
        }
    };
}
